import Vue from 'vue';
import { inputModificationMixin } from '@/common/mixins/inputModificationMixin';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { httpGet } from '@/common/helpers/httpHelper';
import { urls } from '@/common/constants/const-url';
import isEqual from 'lodash/isEqual';
import $ from 'jquery';


library.add(faEye, faEyeSlash);

export default Vue.extend({
    name: 'ChangePasswordModal',
    components: {
        FontAwesomeIcon
    },
    mixins: [inputModificationMixin],
    props: {
        userName: {
            type: String,
            default: ''
        },
        password: {
            type: String,
            default: ''
        }
    },
    data: function () {
        return {
            passwordNew: '',
            passwordConfirm: '',
            msgError: '',
        };
    },
    computed: {
        disabledSave: function () {
            return !this.passwordNew || !this.passwordConfirm;
        },
    },
    mounted: function () {
        $('#changePasswordModal').on('shown.bs.modal', () => {
            this.$nextTick(() => this.$refs.passwordNew.focus());
        });
    },
    methods: {
        changeGuestPassword: function () {
            if (!isEqual(this.passwordNew, this.passwordConfirm)) {
                this.msgError = this.$t('login.differentPasswords');
            } else {
                httpGet(urls.changeGuestPassword, {
                    newPassword: this.passwordNew,
                    login: this.userName,
                    password: this.password,
                })
                    .then(response => {
                        if (response && response.isSuccessful) {
                            $('#changePasswordModal').modal('hide');
                            this.$emit('login', this.userName, this.passwordNew);
                        } else {
                            this.msgError = response.errors.map(error => error.text).join('<br/>');
                        }
                    });
            }
        },
    },
});


// WEBPACK FOOTER //
// ./user/components/login/change-password/change-password.ts